import * as ScrollArea from "@radix-ui/react-scroll-area";

import cn from "@/utils/cn";

import { sizes, variants } from "./utils";

type Props = {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
};

export const Scrollbar = ({ variant = "light", size = "thin" }: Props) => {
  return (
    <ScrollArea.Scrollbar
      className={cn(sizes[size], "flex bg-transparent")}
      orientation="vertical"
    >
      <ScrollArea.Thumb
        className={cn(
          variants[variant],
          "relative flex-1 rounded-[10px] transition-colors before:absolute before:left-1/2 before:top-1/2 before:h-full before:min-h-[44px] before:w-full before:min-w-[44px] before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] ",
        )}
      />
    </ScrollArea.Scrollbar>
  );
};
